import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule
} from '@ngx-formly/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@openng/optimus-ui/tabs';
import { interval, Observable, of, throttle } from 'rxjs';
import { TabsQueryDirective } from '~ngx-shared/directives';

interface TabProps extends FormlyFieldProps {
  query?: string;
}

export interface TabFieldConfig extends FormlyFieldConfig<TabProps> {
  type?: 'tab' | Type<TabTypeComponent>;
}

@Component({
  selector: 'lib-tab-type',
  templateUrl: './tab-type.component.html',
  styleUrl: './tab-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    Tabs,
    TabsQueryDirective,
    TabList,
    Tab,
    NgClass,
    TabPanels,
    TabPanel,
    FormlyModule,
    AsyncPipe
  ]
})
export class TabTypeComponent extends FieldType<FieldTypeConfig<TabProps>> {
  private getFormErrorCount(field: FormlyFieldConfig): number {
    return field.formControl?.invalid &&
      (field.formControl?.touched || field.options?.parentForm?.submitted)
      ? 1
      : 0;
  }

  errorCount(field: FormlyFieldConfig): number {
    if (field.hide) {
      return 0;
    }
    let count = 0;
    if (field.key) {
      count = this.getFormErrorCount(field);
    } else if (field.fieldGroup) {
      count = field.fieldGroup.reduce((total, item) => {
        return total + this.errorCount(item);
      }, 0);
    }
    return count;
  }

  errorCount$(field: FormlyFieldConfig): Observable<number> {
    return of(this.errorCount(field)).pipe(throttle(() => interval(1000)));
  }
}
